import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "app-dialog-editabletexts-validation",
  styleUrls: ["./inspection-report-edit-text-validation-dialog.component.scss"],
  templateUrl: "./inspection-report-edit-text-validation-dialog.component.html",
  standalone: false
})
export class EditableTextsValidationDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<EditableTextsValidationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}
